// src/sections/Desserts/Desserts.js
import React from 'react';
import styles from './Desserts.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeart as solidHeart } from '@fortawesome/free-solid-svg-icons';
import { faHeart as regularHeart } from '@fortawesome/free-regular-svg-icons';

const dessertsData = [
  { id: "dessert-perle-coco", name: "PERLE COCO (1 PIÈCE)", price: "1.50€", description: "" },
  { id: "dessert-nougats-mous", name: "NOUGATS MOUS", price: "2.50€", description: "" },
  { id: "dessert-lychees-sirop", name: "LYCHEES AU SIROP", price: "3.00€", description: "" },
  { id: "dessert-salade-fruits", name: "SALADE DE FRUITS FRAIS", price: "3.50€", description: "" },
  // CORRIGÉ : Prix mis à jour et format du nom harmonisé
  { id: "dessert-panna-cotta", name: "PANNA COTTA (COCO, MANGUE, FRUITS ROUGES)", price: "3.90€", description: "" }, 
  { 
    id: "dessert-declinaison", 
    name: "DÉCLINAISON DE SAVEURS", 
    price: "3.90€", 
    // CORRIGÉ : Description mise à jour pour correspondre à la liste des ingrédients
    description: "Ingrédients : Crème coco vanillé, kiwi, mangue, cube de gelée de coco, lychee, coulis fraise." 
  }
];

const Desserts = ({ id, favorites, addFavorite, removeFavorite }) => {
  
  const isFavorite = (item) => {
    return favorites.some(favItem => favItem.id === item.id);
  };

  const handleFavoriteClick = (item) => {
    if (isFavorite(item)) {
      removeFavorite(item.id);
    } else {
      addFavorite(item);
    }
  };

  return (
    <section id={id} className={styles.desserts}>
      <div className={styles.container}>
        <h2 className={styles.sectionTitle}>NOS DESSERTS</h2>
        <div className={styles.menuList}>
          {dessertsData.map((item) => (
            <div key={item.id} className={styles.menuItem}>
              <div className={styles.itemHeader}>
                <span className={styles.itemName}>{item.name}</span>
                <span className={styles.itemSeparator}></span>
                
                {/* NOUVEAU WRAPPER POUR LE PRIX ET LE BOUTON FAVORIS */}
                <div className={styles.priceAndFavorite}>
                  <span className={styles.itemPrice}>{item.price}</span>
                  <button
                    className={`${styles.favoriteButton} ${isFavorite(item) ? styles.isFavorite : ''}`}
                    onClick={() => handleFavoriteClick(item)}
                    aria-label={isFavorite(item) ? `Retirer ${item.name} des favoris` : `Ajouter ${item.name} aux favoris`}
                  >
                    <FontAwesomeIcon icon={isFavorite(item) ? solidHeart : regularHeart} />
                  </button>
                </div>

              </div>
              {item.description && (
                <p className={styles.itemDescription}>{item.description}</p>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Desserts;